module.exports = __webpack_public_path__ + "img/2-7-encore-wynn.e1da42a8.jpg";